import React, { useState } from "react";
import { SelectCard, Typography, Icon } from "@ann/web-components";
import { CreateViewDetailsModal } from "../../../../components";
import {
  RoleListContainer,
  SelectCardContainer,
  SelectCardContent,
  SelectCardLeftColumn,
  SelectCardRightColumn,
  IconWithNumberContainer,
  ViewDetailsButton,
} from "./RoleList.styled";

const RoleList = ({ onRoleSelect, selectedRole, roles = [] }) => {
  const [selected, setSelected] = useState(selectedRole || null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRoleData, setSelectedRoleData] = useState(null);

  const handleRoleChange = (value) => {
    setSelected(value);
    if (onRoleSelect) {
      // Find the selected role object
      const selectedRoleData = roles.find(role => role.id === value);
      if (selectedRoleData) {
        onRoleSelect({
          name: selectedRoleData.title,
          description: selectedRoleData.description,
        });
      }
    }
  };

  const handleViewDetails = (role) => {
    setSelectedRoleData(role);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedRoleData(null);
  };

  return (
    <RoleListContainer>
      <SelectCardContainer>
        <SelectCard.Group
          kind="radio"
          value={selected}
          onChange={handleRoleChange}
          direction="row"
          itemsPerRow={2}
        >
          {roles.map((role) => (
            <SelectCard key={role.id} id={role.id}>
              <SelectCardContent>
                <SelectCardLeftColumn>
                  <Typography category="title" size="small" weight="bold">
                    {role.title}
                  </Typography>
                  <Typography category="body" size="medium" weight="regular">
                    {role.description}
                  </Typography>
                </SelectCardLeftColumn>
                <SelectCardRightColumn>
                  <IconWithNumberContainer>
                    <Icon name="group" size="medium" />
                    <Typography category="body" size="medium" weight="regular">
                      +{role.userCount}
                    </Typography>
                  </IconWithNumberContainer>
                  <ViewDetailsButton
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewDetails(role);
                    }}
                  >
                    View Details
                  </ViewDetailsButton>
                </SelectCardRightColumn>
              </SelectCardContent>
            </SelectCard>
          ))}
        </SelectCard.Group>
      </SelectCardContainer>
      <CreateViewDetailsModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        roleData={selectedRoleData}
      />
    </RoleListContainer>
  );
};

export default RoleList;

